import React from "react";
import Agent from "./agent.jsx";
export const AddAppointment = async (
  shopId,
  staffId,
  customerId,
  selectedServices,
  date,
  time,
  additionalMinutes,
) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  const params = {
    // replace with actual GUID
    StaffId: staffId, // replace with actual GUID
    CustomerId: customerId, // replace with actual GUID
    ServiceList: selectedServices,
    Date: date, // ISO format is best for C#
    Time: time, // TimeSpan as HH:mm:ss
    AdditionalMinutes: additionalMinutes,
  };

  return await requests.post(
    `/Appointment/CreateDashAppontment`,
    params,
    token,
    shopId,
  );
};

export const AddAnyWayAppointment = async (
  shopId,
  staffId,
  customerId,
  selectedServices,
  date,
  time,
  additionalMinutes,
) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  const params = {
    // replace with actual GUID
    StaffId: staffId, // replace with actual GUID
    CustomerId: customerId, // replace with actual GUID
    ServiceList: selectedServices,
    Date: date, // ISO format is best for C#
    Time: time, // TimeSpan as HH:mm:ss
    AdditionalMinutes: additionalMinutes,
  };
  console.log(params);
  return await requests.post(
    `/Appointment/CreateAnywayAppointment`,
    params,
    token,
    shopId,
  );
};
export const getappointmentsPerDates = async (shopId, fromDate, todate) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  const params = {
    ShopId: shopId,
    FromDate: fromDate || null,
    ToDate: todate || null,
  };
  return await requests.getAtt(
    `/appointment/appointmentsPerDates`,
    params,
    token,
    shopId,
  );
};
export const getAppointmentsByFillter = async (
  shopId,
  date,
  barber,
  customer,
  status,
  refferenceCode,
) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  const params = {
    ShopId: shopId,
    Date: date || null,
    Barber: barber || null,
    Customer: customer || null,
    Status: status,
    RefferenceCode: refferenceCode.trim() === "" ? null : refferenceCode.trim(),
  };
  return await requests.getAtt(
    `/appointment/filterAppointments`,
    params,
    token,
    shopId,
  );
};
export const updateAppointmentStatus = async (
  shopId,
  appointmentId,
  status,
  startTime,
  endTime,
) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  const params = {
    // replace with actual GUID
    ShopId: shopId, // replace with actual GUID
    AppointmentId: appointmentId, // replace with actual GUID
    Status: status,
    StartTime: startTime, // ISO format is best for C#
    EndTime: endTime, // TimeSpan as HH:mm:ss
  };
  return await requests.put(
    `/Appointment/Update-Appointment-status`,
    params,
    token,
    shopId,
  );
};
export const reassignAppointmentCustomer = async (
  shopId,
  appointmentId,
  customer,
) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  const params = {
    // replace with actual GUID
    ShopId: shopId, // replace with actual GUID
    AppointmentId: appointmentId, // replace with actual GUID
    customer: customer,
  };
  return await requests.put(
    `/Appointment/reassign-appointment-customer`,
    params,
    token,
    shopId,
  );
};
